import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { ExperienceWidget } from '../models/experience-widget.model';

export class SetExperienceWidget {
    static readonly type = '[ExperienceWidget] SetExperienceWidget';

    constructor(public payload: ExperienceWidget) {}
}

export class UnsetExperienceWidgets {
    static readonly type = '[ExperienceWidget] UnsetExperienceWidgets';
}

export class UnsetExperienceWidget {
    static readonly type = '[ExperienceWidget] UnsetExperienceWidget';
}

export class FetchExperienceWidget {
    static readonly type = '[ExperienceWidget] FetchExperienceWidget';

    constructor(public payload: string) {}
}

export class FetchExperienceWidgetSuccess {
    static readonly type = '[ExperienceWidget] FetchExperienceWidgetSuccess';

    constructor(public payload: ExperienceWidget) {}
}

export class FetchExperienceWidgetFailure {
    static readonly type = '[ExperienceWidget] FetchExperienceWidgetFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateExperienceWidget {
    static readonly type = '[ExperienceWidget] CreateExperienceWidget';

    constructor(public payload: ExperienceWidget) {}
}

export class CreateExperienceWidgetSuccess {
    static readonly type = '[ExperienceWidget] CreateExperienceWidgetSuccess';

    constructor(public payload: ExperienceWidget) {}
}

export class CreateExperienceWidgetFailure {
    static readonly type = '[ExperienceWidget] CreateExperienceWidgetFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateExperienceWidget {
    static readonly type = '[ExperienceWidget] UpdateExperienceWidget';

    constructor(public payload: ExperienceWidget) {}
}

export class UpdateExperienceWidgetSuccess {
    static readonly type = '[ExperienceWidget] UpdateExperienceWidgetSuccess';

    constructor(public payload: ExperienceWidget) {}
}

export class UpdateExperienceWidgetFailure {
    static readonly type = '[ExperienceWidget] UpdateExperienceWidgetFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}
export class DeleteExperienceWidget {
    static readonly type = '[ExperienceWidget] DeleteExperienceWidget';

    constructor(public payload: string) {}
}

export class DeleteExperienceWidgetSuccess {
    static readonly type = '[ExperienceWidget] DeleteExperienceWidgetSuccess';

    constructor(public payload: string) {}
}

export class DeleteExperienceWidgetFailure {
    static readonly type = '[ExperienceWidget] DeleteExperienceWidgetFailure';

    constructor(public payload: string) {}
}

export class SetExperienceWidgets {
    static readonly type = '[ExperienceWidget] SetExperienceWidgets';

    constructor(public payload: ExperienceWidget[]) {}
}

export class FetchExperienceWidgets {
    static readonly type = '[ExperienceWidget] FetchExperienceWidgets';

    constructor(public payload: { experienceId: string }) {}
}

export class FetchExperienceWidgetsSuccess {
    static readonly type = '[ExperienceWidget] FetchExperienceWidgetsSuccess';
}

export class FetchExperienceWidgetsFailure {
    static readonly type = '[ExperienceWidget] FetchExperienceWidgetsFailure';
}

export class ToggleSelectedExperienceWidget {
    static readonly type = '[ExperienceWidget] ToggleSelectedExperienceWidget';

    constructor(public payload: string) {}
}

export class SelectFilteredExperienceWidgets {
    static readonly type = '[ExperienceWidget] SelectFilteredExperienceWidgets';
}

export class DeselectSelectedExperienceWidgets {
    static readonly type = '[ExperienceWidget] DeselectSelectedExperienceWidgets';
}

export class SearchExperienceWidgets {
    static readonly type = '[ExperienceWidget] SearchExperienceWidgets';

    constructor(public payload: string) {}
}
